














import Vue from 'vue';
import { BFormCheckbox } from 'bootstrap-vue';

export default Vue.extend({
  name: 'SelectAllCheckbox',
  components: {
    BFormCheckbox,
  },
  props: {
    allCount: {
      type: Number,
      required: true,
    },
    selectedCount: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      checked: false,
      indeterminate: false,
    };
  },
  watch: {
    selectedCount: {
      handler: 'updateState',
      immediate: true,
    },
  },
  methods: {
    async updateState() {
      await this.$nextTick();
      this.checked = this.allCount === this.selectedCount ? true : false;
      this.indeterminate = this.selectedCount > 0 && this.selectedCount < this.allCount ? true : false;
    },
    clickHandler() {
      if (this.indeterminate || this.checked) {
        this.$emit('deselectAll');
      } else {
        this.$emit('selectAll');
      }
    },
  },
});
